module.exports = __webpack_public_path__ + "img/Gallery_2_11.2390ecc7.jpeg";